module.exports = "/_next/static/images/RegionalSegment@2x-04a6298c6b6cced10a85cb6d706c0524.png";